<template lang="pug">
  v-chip.mr-2.my-1(
    :color="signature.signed ? 'success' : 'null'"
    small
  ) {{ signature.file.is.name }}
    v-progress-circular.ml-1(
      v-if="signature.signing"
      style="transform: translateX(4px)"
      indeterminate
      size="20"
      width="2"
    )
    v-icon(
      v-else
      right
      @click.stop="signature.signed ? showSignature() : null"
    ) {{ signature.signed ? 'mdi-key' : 'mdi-key_off' }}
</template>

<script>
import ViewSignatures from './ViewSignatures.vue';

export default {
  props: {
    signature: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    showSignature() {
      const { signature } = this;
      this.$modals.show('generic-controller', {
        title: 'Просмотр подписей',
        dialogProps: {
          width: 700,
        },
        component: ViewSignatures,
        componentProps: {
          signatures: [signature],
        },
      });
    },
  },
};
</script>
